module.exports = __webpack_public_path__ + "static/3_3_spam-or-ham_DA-3ce9ab066bdfd73021addd51b0cba798.svg";